export class ACCCompany
{
    public id: string = '';
    public name: string = '';
    public accountId: string = '';
    public trade: string = '';
    public projectSize: number = 0;
    public userSize: number = 0;
    public status: string = '';

    public static fromAutodeskJSON(json: any): ACCCompany
    {
        let company = new ACCCompany();
        company.id = json.id;
        company.name = json.name;
        company.accountId = json.accountId;
        company.trade = json.trade;
        company.projectSize = json.projectSize;
        company.userSize = json.userSize;
        company.status = json.status;
        return company;
    }
}
